"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCellData = exports.isCollapsibleWithClasses = exports.isCollapsibleDataForTable = exports.isCollapsible = void 0;
var react_1 = __importDefault(require("react"));
var isCollapsible = function (arg) {
    return arg && arg.collapsible && arg.main;
};
exports.isCollapsible = isCollapsible;
var isCollapsibleDataForTable = function (arg) {
    return arg && arg.collapsible && arg.main;
};
exports.isCollapsibleDataForTable = isCollapsibleDataForTable;
var isCollapsibleWithClasses = function (arg) {
    return arg && arg.body && react_1.default.isValidElement(arg.body) && arg.className;
};
exports.isCollapsibleWithClasses = isCollapsibleWithClasses;
var transformCellData = function (entry) {
    if (typeof entry === 'string') {
        return { value: entry };
    }
    return entry;
};
exports.transformCellData = transformCellData;
//# sourceMappingURL=utils.js.map